<template>
  <admin-page-shell :title="$t('frontend_groovemail_admin_campaigns_route_page_title')">
    <server-table
      class="text-center groovemail-admin-campaigns-table"
      ref="serverTable"
      :url="adminCampaignListingUrl"
      tableRef="campaignsTable"
      :slotData="adminCampaignTableSlotData"
      :tableColumns="adminCampaignTableColumns"
      :tableOptions="adminCampaignTableOptions"
      tableTitle="frontend_groovemail_broadcasts_route_page_title"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>

    <gs-named-modal
      name="view-campaign-modal"
      id="campaignmessage"
      :title="this.$t('frontend_groovemail_admin_view_campaigns_modal_title')"
    >
      <div class="gm-admin-modal__body">
        <dl class="gm-admin-modal__dl">
          <dt>{{ $t('frontend_groovemail_campain_from') }}</dt>
          <dd>{{ this.model.from }}</dd>
          <dt>{{ $t('frontend_groovemail_campain_to') }}</dt>
          <dd>{{ this.model.to }}</dd>
          <dt>{{ $t('frontend_groovemail_campain_subject') }}</dt>
          <dd>{{ this.model.subject }}</dd>
          <dt>{{ $t('frontend_groovemail_campain_message') }}</dt>
          <dd class="gm-admin-modal__well" v-html="this.model.content"></dd>
        </dl>
      </div>
    </gs-named-modal>
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { adminUrls } from '@/utils/urls.js';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t(
        'frontend_groovemail_components_pricepoint_sidebar_broadcasts'
      ),
    };
  },

  mixins: [demoModeValuesMixin],

  data() {
    return {
      adminCampaignListingUrl: adminUrls.adminCampaignsUrls.campignListing,
      model: {
        from: '',
        to: '',
        subject: '',
        content: '',
      },
      adminCampaignTableColumns: [
        'name',
        'user.email',
        'recipients',
        'open',
        'click',
        'softbounces',
        'hardbounces',
        'unsubscribe_data_count',
        'firstrecipient',
      ],
      adminCampaignTableOptions: {
        perPage: 10,
        debounce: 1000,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: [
          'name',
          'open',
          'click',
          'recipients',
          'softbounces',
          'hardbounces',
          'unsubscribe_data_count',
        ],
        headings: {
          name: () => this.$t('frontend_groovemail_campaign_name'),
          'user.email': () =>
            this.$t('frontend_groovemail_admin_campaign_user_email'),
          recipients: () =>
            this.$t('frontend_groovemail_admin_campaign_total_recipients'),
          open: () => this.$t('frontend_groovemail_campains_show_opens'),
          click: () => this.$t('frontend_groovemail_campains_show_clicks'),
          softbounces: () =>
            this.$t('frontend_groovemail_admin_campaign_soft_bounces'),
          hardbounces: () =>
            this.$t('frontend_groovemail_admin_campaign_hard_bounces'),
          unsubscribe_data_count: () =>
            this.$t('frontend_groovemail_admin_campaign_unsubscibers'),
          firstrecipient: () =>
            this.$t(
              'frontend_groovemail_admin_campaign_first_recipient_detail'
            ),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              user: {
                email: self.basicEmailText,
              } }));

            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },
    };
  },

  components: {
    AdminPageShell,
    VuePerfectScrollbar,
    ServerTable,
  },

  created() {
    self = this;
  },

  watch: {
    // Used to refresh campaigns table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.campaignsTable.refresh();
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    /**	
     * Returns slot data for admin campaign table.
     * @return {array} details for slot columns for admin campaign table.
    */
    adminCampaignTableSlotData() {
      return [
        {
          slotName: 'recipients',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.recipients ? props.row.recipients : 0;
          },
        },
        {
          slotName: 'open',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.open ? props.row.open : 0;
          },
        },
        {
          slotName: 'click',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.click ? props.row.click : 0;
          },
        },
        {
          slotName: 'softbounces',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.softbounces ? props.row.softbounces : 0;
          },
        },
        {
          slotName: 'hardbounces',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.hardbounces ? props.row.hardbounces : 0;
          },
        },
        {
          slotName: 'unsubscribe_data_count',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.unsubscribe_data_count
              ? props.row.unsubscribe_data_count
              : 0;
          },
        },
        {
          slotName: 'firstrecipient',
          slotType: 'envelopeIcon',
          conditions: (props) => {
            return props.row.firstrecipient != null;
          },
          callback: (props) => this.openEmail(props.row),
        },
      ];
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    /**
     * Opens a modal to display details of Email (from, to subject & content).
     * @param {object} row contains detail of an email.
     */
    openEmail(row) {
      this.model.from = row.firstrecipient.sender;
      this.model.to = row.firstrecipient.recipient;
      this.model.subject = row.firstrecipient.subject;
      this.model.content = row.firstrecipient.content;
      this.$root.$emit('modal-open', 'view-campaign-modal');
    },
  },
};
</script>


<style lang="scss">
.groovemail-admin-campaigns-table #gd-server-table-view {
  .VueTables--server table {
    th:nth-child(1),
    th:nth-child(6),
    td:nth-child(1),
    td:nth-child(6) {
      width: 25%;
    }
    th:nth-child(4),
    td:nth-child(4) {
      width: 10%;
    }
    th:nth-child(2),
    th:nth-child(3),
    th:nth-child(5),
    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(5) {
      width: 9%;
    }
  }
}
</style>
